import React from 'react'
import { Box, Typography } from '@mui/material'
import Container from '@mui/material/Container'
import SETTINGS from '@/src/settings'

const boxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
}

const textStyle = {
  color: '#FFFFFF',
  marginBottom: '8px',
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  textAlign: 'center',
}

const boxInfoStyles = {
  borderRadius: '50%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '100px',
  width: '100px',
  border: '7px solid white',
}

const pastilleName = {
  fontSize: '12px',
  fontWeight: 'bold',
  backgroundColor: '#537CEA',
  borderRadius: '20px',
  height: '30px',
  padding: '10px',
  width: '130px',
  color: '#FFFFFF',
  display: 'inline-block',
  lineHeight: '1',
}

const HomeCallTeam: React.FC = () => {
  return (
    <Container
      className="rounded-xl"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'top',
        alignItems: 'center',
        backgroundColor: '#3C5DB4',
      }}
      maxWidth="xl"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'top',
          textAlign: 'center',
        }}
        maxWidth="lg"
      >
        <Typography
          style={{ fontWeight: 'bold', fontSize: '24px', marginTop: 16, color: '#FFFF' }}
          variant="subtitle2"
          gutterBottom
        >
          Une équipe pour vous accompagner
        </Typography>
        <Typography
          style={{ marginTop: '10px', color: '#FFFF', borderRadius: '30' }}
          variant="body2"
          gutterBottom
        >
          Contact :{' '}
          <span style={{ fontWeight: 'bold' }}>{SETTINGS.contact.phone_pharmedistore}</span>
        </Typography>

        <Box
          sx={{
            marginTop: 2,
            marginBottom: 2,
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            justifyContent: 'space-around',
            gap: { xs: 5, md: 8 },
          }}
        >
          <Box
            sx={{
              ...boxStyle,
            }}
          >
            <Box
              sx={{
                ...boxInfoStyles,
                backgroundImage: `url('/images/home/emerik.png')`,
              }}
            ></Box>
            <Typography variant="body2" sx={{ ...textStyle, ...pastilleName }}>
              Emerik
            </Typography>
          </Box>
          <Box
            sx={{
              ...boxStyle,
            }}
          >
            <Box
              sx={{
                ...boxInfoStyles,
                backgroundImage: `url('/images/home/katia.svg')`,
              }}
            ></Box>
            <Typography variant="body2" sx={{ ...textStyle, ...pastilleName }}>
              Katia
            </Typography>
          </Box>

          <Box
            sx={{
              ...boxStyle,
            }}
          >
            <Box
              sx={{
                ...boxInfoStyles,
                backgroundImage: `url('/images/home/fabien.svg')`,
              }}
            ></Box>
            <Typography variant="body2" sx={{ ...textStyle, ...pastilleName }}>
              Fabien
            </Typography>
          </Box>

          <Box
            sx={{
              ...boxStyle,
            }}
          >
            <Box
              sx={{
                ...boxInfoStyles,
                backgroundImage: `url('/images/home/margaux.svg')`,
              }}
            ></Box>
            <Typography variant="body2" sx={{ ...textStyle, ...pastilleName }}>
              Margaux
            </Typography>
          </Box>

          <Box
            sx={{
              ...boxStyle,
            }}
          >
            <Box
              sx={{
                ...boxInfoStyles,
                backgroundImage: `url('/images/home/jonathan.svg')`,
              }}
            ></Box>
            <Typography variant="body2" sx={{ ...textStyle, ...pastilleName }}>
              Jonathan
            </Typography>
          </Box>

          <Box
            sx={{
              ...boxStyle,
            }}
          >
            <Box
              sx={{
                ...boxInfoStyles,
                backgroundImage: `url('/images/home/nathalie.svg')`,
              }}
            ></Box>
            <Typography variant="body2" sx={{ ...textStyle, ...pastilleName }}>
              Nathalie
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  )
}

export default HomeCallTeam
